import { render, staticRenderFns } from "./SCM8Common.vue?vue&type=template&id=02fed5ff&"
import script from "./SCM8Common.vue?vue&type=script&lang=js&"
export * from "./SCM8Common.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports